const configDefaultForm = {
    size: null,
    variant: undefined,
    inputVariant: undefined,
    fullWidth: true,
    debounceTime: 200,
    notDefaultNumber: true,
    datePicker: {
        notValueMillisecond: false,
    }
}

export default configDefaultForm;